import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 9ACB9882-BE7B-44A3-AFCC-FDA2A5061EF1
 * name calendar-today-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-today-outline.svg
 * tags
 * - Date / Time 
 */
export const CalendarTodayOutlineIcon = createSvgIcon(<><path d="M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.89 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3M19 19H5V9H19V19M19 7H5V5H19M7 11H12V16H7" /></>, 'CalendarTodayOutlineIcon');
export default CalendarTodayOutlineIcon